export default "__VITE_PUBLIC_ASSET__8b69f0b0__"